const Logout = {
  buttonLabel: "Logout",
  endSessionLabel: "End session",
  caplogout: "LOGOUT"
};

export default Logout;
